/** 
 * NonNullableObjectProxy
 * 
 * Acts as the middleman before setting the value in the object.
 * Disallow setting of any null values, if set null to an existing property it'll delete the property.
 * 
 * @author Darrus Goh
 */
export default function NonNullableObjectProxy(obj) {
    return new Proxy(obj, {
        set(target, property, value) {
            if (value !== null && property !== null && property !== 'null' && property.trim() !== '') {
                target[property] = value;
            } else if(target.hasOwnProperty(property)) {
                delete target[property];
            }
            return true;
        }
    })
}